var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"page"},[_c('div',[_c('h2',[_vm._v("Exiting groups")]),_c('p',[_vm._v("To exit a group:")]),_c('ol',[_c('li',[_vm._v("Go to the group in ToTok, then tap the group name at the top.")]),_c('li',[_vm._v("Scroll down. Then tap "),_c('strong',[_vm._v("Leave Group > OK")]),_vm._v(".")])])])])])
}]

export { render, staticRenderFns }